/**
 * 신청서 지역(area) 포맷 유틸
 *
 * 표준 표기: "시/도(축약) 시/군/구" 예) "서울 성북구", "경기 용인시", "인천 서구"
 * 카카오 우편번호 API의 sido/sigungu 조합과 동일.
 *
 * BORI-94: 관리자 등록 시 sigungu만 저장하면 "성북구"로 남아 정렬·집계가 깨짐.
 */

const SIDO_SHORT = {
  서울특별시: "서울",
  부산광역시: "부산",
  대구광역시: "대구",
  인천광역시: "인천",
  광주광역시: "광주",
  대전광역시: "대전",
  울산광역시: "울산",
  세종특별자치시: "세종",
  경기도: "경기",
  강원도: "강원",
  강원특별자치도: "강원",
  충청북도: "충북",
  충청남도: "충남",
  전라북도: "전북",
  전북특별자치도: "전북",
  전라남도: "전남",
  경상북도: "경북",
  경상남도: "경남",
  제주도: "제주",
  제주특별자치도: "제주"
};

/**
 * 시/도 정식명 → 축약 (서울특별시 → 서울, 경기도 → 경기)
 */
export function shortenSido(sido) {
  if (!sido) return "";
  const trimmed = String(sido).trim();
  if (SIDO_SHORT[trimmed]) return SIDO_SHORT[trimmed];
  // 이미 축약이거나 매핑 없는 경우: 접미사 제거 시도
  return (
    trimmed
      .replace(/특별자치시$/, "")
      .replace(/특별자치도$/, "")
      .replace(/특별시$/, "")
      .replace(/광역시$/, "") || trimmed
  );
}

/**
 * 카카오 우편번호 선택 결과 → 신청 지역 문자열
 * @param {object} data daum.Postcode oncomplete data
 * @returns {string} 예: "서울 성북구"
 */
export function formatAreaFromPostcode(data) {
  if (!data) return "";
  const sido = shortenSido(data.sido || "");
  const sigungu = String(data.sigungu || "").trim();
  if (sido && sigungu) return `${sido} ${sigungu}`;
  return sido || sigungu || "";
}

/**
 * address1에서 시/도(축약) + 시/군/구 추출
 * @param {string} address1 도로명/지번 주소
 * @returns {string}
 */
export function formatAreaFromAddress(address1) {
  if (!address1 || !String(address1).trim()) return "";
  const parts = String(address1)
    .trim()
    .split(/\s+/);
  if (parts.length === 0) return "";
  const sido = shortenSido(parts[0]);
  if (parts.length >= 2) {
    return `${sido} ${parts[1]}`;
  }
  return sido;
}

/**
 * 목록/엑셀 표시용. area가 구만 있으면 address1으로 보정.
 * @param {{ area?: string, address1?: string }} application
 * @returns {string}
 */
export function extractDisplayArea(application) {
  if (!application) return "";
  const area = (application.area || "").trim();
  const fromAddr = formatAreaFromAddress(application.address1);

  if (area) {
    // "서울 성북구"처럼 공백 포함이면 표준 형식으로 간주
    if (area.includes(" ")) return area;
    // "성북구"만 저장된 레거시 → address1 보정이 가능하면 사용
    if (fromAddr) return fromAddr;
    return area;
  }
  return fromAddr;
}
